import {
  faGithub,
  faInstagram,
  faLinkedin,
  
  
} from '@fortawesome/free-brands-svg-icons'
import {
  faBars,
  faClose,
  faEnvelope,
  faHome,
  faBook,
  faSuitcase,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import useDevMode from '../devmode/usedevmode';
import bootSound from '../audio/boot.mp3';
import { initBootAudio } from '../audio/bootAudio';
import { enterFullscreen } from '../devmode/fullscreen';
import { Link, NavLink } from 'react-router-dom'
import LogoS from '../../assets/images/logo.svg'

import './index.scss'

const Sidebar = () => {
  const [showNav, setShowNav] = useState(false);
    const { enterDevMode } = useDevMode();

  return (
    <div className="nav-bar">
      <Link
        className="logo"
        to="/"
        onClick={() => setShowNav(false)}>
        <img src={LogoS} alt="Logo" />
        {}
      </Link>
      <nav className={showNav ? 'mobile-show' : ''}>
        <NavLink
          exact="true"
          activeclassname="active"
          to="/"
          onClick={() => setShowNav(false)}>
          <FontAwesomeIcon icon={faHome} color="#ffff" />
        </NavLink>
        <NavLink
          activeclassname="active"
          className="about-link"
          to="/about"
          onClick={() => setShowNav(false)}>
          <FontAwesomeIcon icon={faUser} color="#ffff" />
        </NavLink>
        <NavLink
          activeclassname="active"
          className="skills-link"
          to="/skills"
          onClick={() => setShowNav(false)}
        >
          <FontAwesomeIcon icon={faSuitcase} color="#ffff" />
        </NavLink>
        <NavLink
          activeclassname="active"
          className="contact-link"
          to="/contact"
          onClick={() => setShowNav(false)}
        >

          <FontAwesomeIcon icon={faEnvelope} color="#ffff" />
        </NavLink>
        <NavLink
          activeclassname="active"
          className="guestbook-link"
          to="/projects"
          onClick={() => setShowNav(false)}
        >

          <FontAwesomeIcon icon={faBook} color="#ffff" />
        </NavLink>
        <FontAwesomeIcon
          onClick={() => setShowNav(false)}
          icon={faClose}
          color="rgb(201, 204, 214)"
          size="3x"
          className='close-icon' />
      </nav>

        <div
            className="dev-toggle"
            onClick={() => {
                initBootAudio(bootSound);   
                enterFullscreen();          
                enterDevMode();             
            }}
        >
        <span className="dev-toggle-label">DEV</span>
            <div className="dev-toggle-switch">
                <span className="dev-toggle-knob" />
            </div>
        </div>

        <ul>
        <li>
          <a
            href="https://linkedin.com/in/khwahish-s-a633a82a0"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon
              icon={faLinkedin}
              color="#ffff"
              className="anchor-icon"
            />
          </a>
        </li>
        <li>
          <a
            href="https://github.com/kwhx"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon
              icon={faGithub}
              color="#ffff"
              className="anchor-icon"
            />
          </a>
        </li>
      </ul>
      <FontAwesomeIcon
        onClick={() => setShowNav(true)}
        icon={faBars}
        color="rgb(201, 204, 214)"
        size="3x"
        className='hamburger-icon' />
    </div>
  )
}

export default Sidebar
